import { SwitchWithLabel } from "./switch-with-label"

export const SwitchInactivePairs = ({
  checked,
  onCheckedChange,
}: {
  checked: boolean
  onCheckedChange: (value: boolean) => void
}) => {
  return <SwitchWithLabel label="Show Inactive Pairs" checked={checked} onCheckedChange={onCheckedChange} />
}
